"use client";

import Link from "next/link";
import { FormEvent, useState } from "react";
import { useRouter } from "next/navigation";
import { SiteHeader } from "@/components/site-chrome";
import { usePrefs } from "@/components/prefs-provider";

export default function RegisterPage() {
  const router = useRouter();
  const { t } = usePrefs();
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  async function onSubmit(e: FormEvent<HTMLFormElement>) {
    e.preventDefault();
    setLoading(true);
    setError("");
    const fd = new FormData(e.currentTarget);
    const res = await fetch("/api/auth/register", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        name: fd.get("name"),
        email: fd.get("email"),
        phone: fd.get("phone"),
        password: fd.get("password"),
      }),
    });
    const data = await res.json();
    setLoading(false);
    if (!res.ok) {
      setError(data.error || t.auth.registerFailed);
      return;
    }
    router.push("/plans");
  }

  return (
    <div className="hero-mesh min-h-screen">
      <SiteHeader solid />
      <main className="mx-auto flex min-h-screen max-w-md flex-col justify-center px-4 py-24">
        <p className="font-display text-3xl font-bold">
          {t.auth.registerTitle} <span className="text-[var(--teal)]">{t.auth.registerParent}</span>
        </p>
        <p className="mt-2 text-[var(--ink-soft)]">{t.auth.registerLead}</p>
        <form onSubmit={onSubmit} className="mt-8 space-y-4">
          <div>
            <label className="mb-1.5 block text-sm font-medium">{t.auth.fullName}</label>
            <input name="name" required className="input" placeholder="Dana Cohen" />
          </div>
          <div>
            <label className="mb-1.5 block text-sm font-medium">{t.auth.email}</label>
            <input name="email" type="email" required className="input" placeholder="you@email.com" />
          </div>
          <div>
            <label className="mb-1.5 block text-sm font-medium">{t.auth.phone}</label>
            <input name="phone" required className="input" placeholder="+9725..." />
          </div>
          <div>
            <label className="mb-1.5 block text-sm font-medium">{t.auth.password}</label>
            <input name="password" type="password" required minLength={6} className="input" />
          </div>
          {error && <p className="text-sm text-[var(--alert)]">{error}</p>}
          <button disabled={loading} className="btn-primary w-full" type="submit">
            {loading ? t.auth.creating : t.auth.create}
          </button>
        </form>
        <p className="mt-6 text-sm text-[var(--ink-soft)]">
          {t.auth.haveAccount}{" "}
          <Link href="/login" className="font-semibold text-[var(--teal)]">
            {t.auth.login}
          </Link>
        </p>
      </main>
    </div>
  );
}
